<script setup lang="ts">
import { CreateButton } from '@/components/Buttons'
import InformationBaseCard from '@/components/Cards/InformationBaseCard.vue'
import InputField from '@/components/Fields/InputField.vue'
import StackLayout from '@/components/Layouts/StackLayout.vue'
import PermissionWrapper from '@/components/Permission/PermissionWrapper.vue'
import type { DeviceTypesModel } from '@/types/models/DeviceTypesModel'
import type { PermissionsEnums } from '@/types/permissions/PermissionsEnum'

type Props = {
    confirmLabel?: string
    data?: Partial<DeviceTypesModel>
    editPermission?: PermissionsEnums
    hasPermission?: boolean
    loading?: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<DeviceTypesModel>): void
    (e: 'confirm'): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout :gap="16" direction="column">
        <InformationBaseCard :label="$t('deviceConfig.types.title.informations')">
            <StackLayout direction="row" :gap="8">
                <InputField
                    :label="$t('deviceConfig.types.model.name')"
                    :modelValue="data?.name"
                    @change="$emit('change', { name: $event })" />
            </StackLayout>
        </InformationBaseCard>
        <PermissionWrapper :permission="editPermission" :hasPermission="hasPermission">
            <CreateButton
                :loading="loading"
                :label="confirmLabel ?? $t('deviceConfig.types.buttons.createNewType')"
                @click="$emit('confirm')" />
        </PermissionWrapper>
    </StackLayout>
</template>
